var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgECommerce = function SvgECommerce(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M3.347 6h13.306c.338 0 .673.062.98.183.308.12.58.296.801.515.22.218.383.475.476.753.093.277.114.568.063.853L17.5 16.456c-.128.708-.55 1.355-1.187 1.821-.639.467-1.452.723-2.293.723H5.98c-.842 0-1.655-.257-2.293-.723-.638-.467-1.06-1.113-1.187-1.821L1.027 8.304a1.7 1.7 0 0 1 .063-.853c.093-.278.255-.535.476-.753a2.35 2.35 0 0 1 .8-.515c.308-.12.643-.183.981-.183"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M6.478 9V4c0-.796.37-1.559 1.03-2.121S9.065 1 9.999 1s1.829.316 2.49.879c.66.562 1.03 1.325 1.03 2.121v5"
  })));
};
export default SvgECommerce;